import LoadingDots from 'components/LoadingDots';
import Modal from 'components/Modal';
import ModalBody from 'components/Modal/ModalBody';
import { TransferStatus } from 'model/booking/Transfers';
import { useTransferBookingContext } from 'modules/host-transfer-booking/context/TransferBookingContext';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { STATUS_PENDING } from '~/constants';

import BookingTransferred from './BookingTransferred';
import ConfirmTransfer from './ConfirmTransfer';

function AcceptTransferModal() {
  const { status, transferRequest, transferStatus, acceptTransfer } =
    useTransferBookingContext();
  const history = useHistory();

  const handleConfirmTransfer = async () => {
    await acceptTransfer();
    history.goBack();
  };

  return (
    <Modal show onClose={history.goBack}>
      <ModalBody>
        {status === STATUS_PENDING ? (
          <LoadingDots />
        ) : transferStatus === TransferStatus.ACCEPTED ? (
          <BookingTransferred
            bookingId={transferRequest.bookingId}
            oldHostName={transferRequest.initialHost.firstName}
          />
        ) : (
          <ConfirmTransfer
            dateTime={transferRequest.booking.tripDateTime}
            onConfirm={handleConfirmTransfer}
            onCancel={history.goBack}
          />
        )}
      </ModalBody>
    </Modal>
  );
}

export default AcceptTransferModal;
